<template>
  <div v-if="visible">
    <component
      :is="component"
      v-if="def.componentPath"
      :def="def"
      :model="!def.panels[0].relationPath ? Model : def.panels[0].relationPath.split('.').reduce((m, p) => m[p], Model)"
    ></component>
    <v-expansion-panels 
      v-else-if="def.page.form.pages.length > 1 || def.page.sections.length > 1 || (def.panels && def.panels[0] && def.panels[0].grids)"
      v-model="open"
      multiple
      flat
      :readonly="def.expandable === undefined ? false :!def.expandable"
    >
      <v-expansion-panel>
        <v-expansion-panel-header
          class="expansion-header G2--text"
          style="height : 78px;"
        >
          <div>
            <div class="section-title G2--text my-4">
              {{ $t(def) }}
            </div>
            <AppPortalTarget 
              :name="`${def.id}.rightSection`"
              class="section-portal-right G2--text my-4"
            >
              <!--
              This component can be located anwhere in your App.
              The slot content of the above portal component will be rendered here.
              -->
            </AppPortalTarget>
          </div>
          <AppPortalTarget 
            :name="`${def.id}.leftSection`"
            class="section-portal-left"
          >
            <!--
            This component can be located anwhere in your App.
            The slot content of the above portal component will be rendered here.
            -->
          </AppPortalTarget>
        </v-expansion-panel-header>
        <v-expansion-panel-content
          style="padding: 0 5px 5px!important;" 
          class="section " 
          eager 
        >
          <abr-form-panel
            v-for="panel in def.panels"
            :key="panel.id"
            class="panel"
            :def="{ section: def, ...panel }"
            :form-model="Model"
            :modal="modal"
            :model="!panel.relationPath ? Model : panel.relationPath.split('.').reduce((m, p) => m[p], Model)"
            @change="onChange($event)"
          ></abr-form-panel>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-else>
      <AppCard
        :flat="true"
        class="px-4"
        :tile="true"
      >
        <abr-form-panel
          v-for="panel in def.panels"
          :key="panel.id"
          class="my-3 panel"
          :def="{ section: def, ...panel }"
          :form-model="Model"
          :modal="modal"
          :model="!panel.relationPath ? Model : panel.relationPath.split('.').reduce((m, p) => m[p], Model)"
          @change="onChange($event)"
        ></abr-form-panel>
      </AppCard>
    </div>
  </div>
</template>

<script>
import AbrFormPanel from "@/components/form/AbrFormPanel";
import AppCard from "@/components/library/container/AppCard";
import AppPortalTarget from "@/components/library/portal/AppPortalTarget"

export default {
  name: "AbrFormSection",
  components: {
    AppCard,
    "abr-form-panel": AbrFormPanel,
    AppPortalTarget
  },
  props: ["def", "model","modal"],
  data: vm => ({
      open: [0],
      Model: vm.model,
      visible: true,
      isExpanded : true
  }),
  computed: {
    component() {
      return () =>
        this.def.componentPath && import("@/ext/" + this.def.componentPath);
    },

  },
  created() {
    this.$watch("model", async () => {
      this.visible = await this.$checkVisibility(this.def);
    }, { deep: true, immediate: true });
  },
  methods: {
    onChange(event){
      this.Model = { ...event }
    },
    onExpanded(payload) {
      this.isExpanded = this.def.expandable ? this.def.expandable : payload;
      // payload ? this.$set(this.open, 0, 0) : this.open.pop();
      this.isExpanded ? this.$set(this.open, 0, 0) : this.open.pop();
    }
  },
};
</script>
<style>
.expansion-header{
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 28px;
  text-align: right;
}
.section-title{
  width: 200px;
  display: inline-block;
  line-height: 28px;
  min-width: 26%;
  font-size: 16px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  
}
.section {
  min-height: 100px !important;
  padding-bottom: 0 !important;
}
.v-expansion-panel > .v-expansion-panel-header {
  min-height: 48px !important;
  border-bottom: none;
}

.panel{
  border-bottom: solid 0.5px rgba(224, 224, 224, 1)
}
.panel:last-child{
  border-bottom: none;
}
.section-portal-left{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-left: 10px;
}
.section-portal-right{
  display: inline-block;
  font-size: 12px;
  line-height: 21px;
  padding-right: 18px;
}
</style>
